<template>
  <section
    id="membership-path-choice"
    class="membership-path-choice-panel self-service-card"
    aria-label="参与方式选择"
  >
    <div class="card-heading">
      <div>
        <h3>请选择参与方式</h3>
        <p class="service-hint">请选择个人会员、单位会员关联用户或非会员。单位会员关联须经秘书处确认，不会转换为个人会员。</p>
      </div>
    </div>
    <div class="membership-choice-grid membership-choice-grid--inline">
      <button
        type="button"
        class="choice-card choice-card-member"
        :disabled="front.membershipChoiceSubmitting"
        @click="front.chooseMembershipPath('member')"
      >
        <strong>申请成为会员</strong>
        <span>会费按类型收取（普通/学生 ¥100/年，外籍 $50/年，理事类按当届档位）；会员价参会；须提交入会申请并缴纳会费</span>
        <small>可申请：普通会员 · 学生会员 · 外籍会员 · 理事类（四档）</small>
      </button>
      <button
        type="button"
        class="choice-card choice-card-organization"
        :disabled="front.membershipChoiceSubmitting"
        @click="openOrganizationRequest"
      >
        <strong>我是单位会员关联用户</strong>
        <span>适用于所在单位已经是非理事单位会员的联系人或员工；提交单位信息后由秘书处核实绑定</span>
        <small>审核通过后享受会议会员权益，不生成个人会员证书</small>
      </button>
      <button
        type="button"
        class="choice-card choice-card-non-member"
        :disabled="front.membershipChoiceSubmitting"
        @click="front.chooseMembershipPath('non_member')"
      >
        <strong>暂不以会员身份使用</strong>
        <span>免费使用基础服务；会议按非会员价（学生代表 / 普通代表）；可直接绑定分会并报名</span>
        <small>之后可在本页升级为正式会员</small>
      </button>
    </div>
    <p v-if="front.selfServiceStatus" class="service-notice" role="status">{{ front.selfServiceStatus }}</p>

    <div v-if="organizationDialogOpen" class="auth-dialog-backdrop" role="dialog" aria-modal="true" aria-label="申请关联单位会员">
      <article class="auth-dialog organization-request-dialog">
        <div class="auth-dialog-head">
          <h3>申请关联单位会员</h3>
          <button type="button" class="text-link" @click="organizationDialogOpen = false">关闭</button>
        </div>
        <div class="organization-request-copy">
          <p>请填写您所在的单位会员信息。秘书处将在后台核对单位档案和人员关系，确认后权益自动生效。</p>
          <p>该关联不会把您转换为个人会员，也不参与终身会员管理。</p>
        </div>
        <label class="organization-request-field">
          <span>单位名称 <em>*</em></span>
          <input v-model.trim="organizationForm.organizationName" type="text" maxlength="200" placeholder="请输入单位完整名称" />
        </label>
        <label class="organization-request-field">
          <span>统一社会信用代码/税号</span>
          <input v-model.trim="organizationForm.creditCode" type="text" maxlength="64" placeholder="选填，用于秘书处快速核对" />
        </label>
        <p v-if="formError" class="organization-request-error" role="alert">{{ formError }}</p>
        <div class="organization-request-actions">
          <button type="button" class="secondary-action" @click="organizationDialogOpen = false">取消</button>
          <button type="button" class="primary-action" :disabled="front.membershipChoiceSubmitting" @click="submitOrganizationRequest">
            {{ front.membershipChoiceSubmitting ? '正在提交…' : '提交关联申请' }}
          </button>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MembershipPathChoicePanel',
  inject: ['front'],
  data() {
    return {
      organizationDialogOpen: false,
      organizationForm: { organizationName: '', creditCode: '' },
      formError: ''
    }
  },
  methods: {
    openOrganizationRequest() {
      this.organizationForm = {
        organizationName: (this.front.profileForm && this.front.profileForm.unit) || '',
        creditCode: ''
      }
      this.formError = ''
      this.organizationDialogOpen = true
    },
    async submitOrganizationRequest() {
      if (!this.organizationForm.organizationName) {
        this.formError = '请填写所属单位名称'
        return
      }
      this.formError = ''
      const success = await this.front.chooseOrganizationMembershipPath({ ...this.organizationForm })
      if (success) {
        this.organizationDialogOpen = false
      }
    }
  }
}
</script>

<style scoped>
.membership-choice-grid--inline { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.choice-card-organization { border-top-color: #b08a2e !important; }
.organization-request-dialog { width: min(560px, 100%); gap: 16px; }
.organization-request-copy { padding: 12px 14px; border-radius: 8px; background: #f5f8fb; color: #526579; line-height: 1.65; }
.organization-request-copy p { margin: 0; }
.organization-request-copy p + p { margin-top: 6px; }
.organization-request-field { display: grid; gap: 7px; color: #26394b; font-weight: 700; }
.organization-request-field em { color: #c2413b; font-style: normal; }
.organization-request-field input { box-sizing: border-box; width: 100%; border: 1px solid #cbd5df; border-radius: 6px; padding: 11px 12px; font: inherit; font-weight: 400; }
.organization-request-error { margin: 0; color: #b42318; font-size: 14px; }
.organization-request-actions { display: flex; justify-content: flex-end; gap: 10px; }
@media (max-width: 980px) { .membership-choice-grid--inline { grid-template-columns: 1fr; } }
</style>
